module.exports = __webpack_public_path__ + "static/media/LogicWheel5_1_4.3581a845.png";